import React, { useRef } from "react";
import emailjs from "emailjs-com";
import { Container, Form } from "react-bootstrap";
import logoMail from "./../../images/icons/send.gif";

const Contact = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();
    alert("Email Sent Successfully!");

    emailjs
      .sendForm(
        "rahath123",
        "template_ztlbex5",
        form.current,
        "user_3wjBqrZ9hDylfaq0UeUMK"
      )

      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    form.current.reset();
  };

  return (
    <Container className="d-flex justify-content-center align-items-center my-5">
      <form className="w-100" ref={form} onSubmit={sendEmail}>
        <Form.Floating className="mb-3">
          <Form.Control type="text" name="user_name" required />
          <label htmlFor="floatingInputCustom">Name</label>
        </Form.Floating>

        <Form.Floating className="mb-3">
          <Form.Control
            type="email"
            name="user_email"
            required
            placeholder="name@example.com"
          />
          <label htmlFor="floatingInputCustom">Your Email</label>
        </Form.Floating>

        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
          <Form.Label>Your Message :</Form.Label>
          <Form.Control name="message" as="textarea" rows={3} />
        </Form.Group>

        <input className="btn btn-success rounded-pill " type="submit" value="Send" />
        <img className="" src={logoMail} width="60px" alt="" />
      </form>
    </Container>
  );
};

export default Contact;
